module.exports = __webpack_public_path__ + "a207f783b3bc2cc98762ffadef789cf2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/heartbeat.png
// module id = 2751
// module chunks = 0